/* eslint-disable no-nested-ternary */
import { Badge } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import IconActive from '../../icons/IconActive';
import IconNonActive from '../../icons/IconNonActive';
export default function BadgeStatus({ label, withIcon }) {
  const displayLabel = {
    'ACTIVE': 'Aktif',
    'SCHEDULED': 'Belum Aktif',
    'INACTIVE': 'Tidak Aktif',
  }[label] || label;

  const color = {
    'Ditolak': 'pink',
    'Disetujui': 'green',
    'Sedang Diproses': 'indigo',
    'Perlu Perbaikan': 'grape',
    'Perlu Diproses': 'orange',
    'primary': 'indigo',
    'Lengkap': 'green',
    'Gagal': 'red',
    'Aktif': 'green',
    'Belum Aktif': 'orange',
    'Tidak Aktif': 'red',
    'permanen': 'green',
    'sementara': 'blue',
    'registrasi': 'orange',
    'Gagal Daftar': 'red',
    'Gagal Perbarui Data': 'red',
    'Stok Tersinkronisasi': 'green',
    'Stok Sedang Disinkron': 'orange',
    'Berhasil Upload': 'blue',
    'On demand': 'green',
    'On Demand': 'green',
    'P3KE': 'blue',
    'BPUM': 'blue',
    'DP3': 'blue',
    'Diaktivasi': 'green',
    'Diblokir': 'red',
    'NIK Diblokir': 'red',
  };

  const icon = {
    'Aktif': <IconActive />,
    'Tidak Aktif': <IconNonActive />,
  };

  return (
    <Badge color={color[displayLabel] || color[label] || 'gray'} style={{ textTransform: 'capitalize', fontWeight: '500' }} variant="light">
      {withIcon && icon[displayLabel]} {displayLabel}
    </Badge>
  );
}

BadgeStatus.propTypes = {
  label: PropTypes.string,
  withIcon: PropTypes.bool,
};
